import axios from 'axios'
import { ANALYSIS_DATA_PROJECTION, validateAnalysisDataProjection } from '@/utils/analysisDataStatus'

const API_BASE = process.env.VUE_APP_API_URL || '/api'

const client = axios.create({
  baseURL: API_BASE,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json'
  }
})

client.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error)
)

export const dashboardV2Api = {
  getSummary: () => client.get('/dashboard/v2/summary'),
  async getAnalysisDataStatus() {
    const payload = await client.get('/dashboard/v2/summary', {
      params: { projection: ANALYSIS_DATA_PROJECTION, _: Date.now() },
      headers: { 'Cache-Control': 'no-cache' },
      timeout: 15000
    })
    return validateAnalysisDataProjection(payload, 'dashboard')
  }
}

export default dashboardV2Api